import { useRoutes } from 'react-router';
import { SnackbarProvider } from 'notistack';
import { CssBaseline, ThemeProvider } from '@mui/material';
import './i18n';
import GlobalStyles from './components/GlobalStyles';
import RTL from './components/RTL';
import SplashScreen from './components/SplashScreen';
import useScrollReset from './hooks/useScrollReset';
import useSettings from './hooks/useSettings';
import useAuth from './hooks/useAuth';
import routes from './routes';
import { createTheme } from './theme';

const App = () => {
  const { settings } = useSettings();
  const auth = useAuth();
  const content = useRoutes(routes);
  useScrollReset();

  const theme = createTheme({
    direction: settings.direction,
    responsiveFontSizes: settings.responsiveFontSizes,
    roundedCorners: settings.roundedCorners,
    theme: settings.theme,
    themeColor: settings.themeColor ?? "#2596be",
  });

  return (
    <ThemeProvider theme={theme}>
      {/* CssBaseline wires `body { color: theme.palette.text.primary;
          background-color: theme.palette.background.default }` so every
          unstyled descendant (Typography without an explicit color,
          plain text nodes, etc.) inherits theme-aware colors. Without
          it, dark-mode text falls back to the browser's default black. */}
      <CssBaseline />
      <RTL direction={settings.direction}>
        <SnackbarProvider
          dense
          maxSnack={3}
        >
          <GlobalStyles />
          {auth.isInitialized ? content : <SplashScreen />}
        </SnackbarProvider>
      </RTL>
    </ThemeProvider>
  );
};

export default App;
